import { mapActions, mapMutations } from "vuex";
import rateComment from "@/components/features/rate-comment/index.vue";

export default {
    name: "HomeWorkRateComment",
    components: {
        rateComment,
    },
    props: {
        homeWork: {
            required: true,
            type: Object,
        },
        focusInput: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            progress: false,
            comment: "",
            inEdit: false,
        };
    },
    created() {
		//console.log('HomeWorkRateComment homeWork:');
		//console.log(this.homeWork);
		//console.log('');
	},
    computed: {
		allowShow(){
			return !this.homeWork.hideRating;
		},
        hasCreatedRateMessage() {
            return Boolean(
                !Array.isArray(this.homeWork.userRating.data) &&
                    this.homeWork.userRating.data.comment
            );
        },
        storedComment() {
            console.log("this.homeWork.userRating.data.comment", this.homeWork);
            return this.homeWork.userRating.data.comment;
        },
    },
    mounted() {
        this.comment = this.storedComment;
    },
    watch: {
        "homeWork.userRating.data"(rate) {
            if (rate.rating) {
                this.inEdit = true;
            }
        },
    },
    methods: {
        ...mapMutations({
            setLessonRate: "coursesHomeWork/SET_RATE",
        }),
        ...mapActions({
            updateRateComment: "coursesHomeWork/UPDATE_RATE_COMMENT",
        }),
        async onSubmit(comment) {
            try {
                this.progress = true;
                await this.updateRateComment({
                    courseId: this.homeWork.courseId,
                    moduleId: this.homeWork.moduleId,
                    homeWorkId: this.homeWork.id,
                    rateId: this.homeWork.userRating.data.id,
                    comment,
                });
                this.inEdit = false;
            } catch (e) {
                // TODO: show toast
                console.error(e.message);
            } finally {
                this.progress = false;
            }
        },
        onCancel() {
            this.inEdit = false;
            this.comment = this.storedComment;
        },
        onNeedEdit() {
            this.inEdit = true;
        },
    },
};
